import axios from "axios";
import { apiCallBegan, apiCallFailed, apiCallSuccess } from "../api";

const baseURL = process.env.REACT_APP_API_BASEURL + "/api/";
const api =
  ({ getState, dispatch }) =>
    (next) =>
      async (action) => {
        const token = localStorage.getItem("token");

        if (action.type !== apiCallBegan.type) return next(action);

        const { url, method, data, onStart, onSuccess, onError, responseType, baseURL: customBaseURL, headers: customHeaders } =
          action.payload;

        const headers = { Authorization: `Bearer ${token}`, Portal: "customer", ...customHeaders };
        
        const finalBaseURL = customBaseURL || baseURL;

        if (onStart) dispatch({ type: onStart });

        next(action);

        try {
          const result = await axios.request({
            baseURL: finalBaseURL,
            url,
            method,
            data,
            headers,
            responseType
          });

          dispatch(apiCallSuccess(result.data));

          if (onSuccess) dispatch({ type: onSuccess, payload: result.data });
          
          return result.data;

        } catch (error) {

          dispatch(apiCallFailed(error.message));

          if (onError) dispatch({ type: onError, payload: error.message });
          
          return Promise.reject(error);
        }
      };

export default api;
